import { getTokenValue } from "../../TokenStyles";

interface Props {
  rotation: number;
  high?: boolean;
  color?: string;
}

export const OffscreenPanoMarker = ({ rotation, high = false, color = "--color-primary-50" }: Props) => (
  <svg
    viewBox="0 0 50 50"
    width={288}
    height={288}
    xmlns="http://www.w3.org/2000/svg"
    fillOpacity={0.75}
  >
    <defs>
      <mask id="pointer-mask" fillOpacity="1">
        <rect x="0" y="0" width="50" height="50" rx="16" ry="16" fill="#FFF" />
        <circle cx="25" cy="25" r="16" fill="#000" />
      </mask>
    </defs>

    <polygon
      id="pointer"
      mask="url(#pointer-mask)"
      points="25 4, 35 15, 15 15"
      fill={getTokenValue(color)}
      stroke="#FFF"
      strokeWidth={2}
      transform-origin="25 25"
      transform={`rotate(${rotation})`}
    />

    <circle fill="#FFF" cx="25" cy="25" r="16" />
    <circle fill={getTokenValue(color)} cx="25" cy="25" r="14" />
    <circle fill="#FFF" fillRule="nonzero" cx="25" cy="25" r="2.1" />
    { high && <path
      d="M12 32c1.6-.9 3-1.2 4-.9 1 .3 2 .8 3 1.7a8 8 0 014-1c1.6 0 3 .4 4 1 1-1 2-1.5 3-1.7 1-.2 2.4.1 4 1-3.6 3.7-7.3 5.6-11 5.6s-7.3-1.9-11-5.6z"
      fill="#FFF" transform="translate(2 2)" /> }
    <path
      d="M6 1.3L4.8 2.7H2.7c-.8 0-1.4.6-1.4 1.3v8c0 .7.6 1.3 1.4 1.3h10.6c.8 0 1.4-.6 1.4-1.3V4c0-.7-.6-1.3-1.4-1.3h-2L10 1.3H6zm2 10a3.3 3.3 0 110-6.6 3.3 3.3 0 010 6.6z"
      fill="#FFF"
      fillRule="nonzero"
      transform="translate(17 17)"
    />
  </svg>
);
